import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import SERVICES_API_V1 from 'api/services/v1'
import { PATCH_ACCOUNT_ADVERTISER_INFO } from 'modules/Services/types'

function* patchAccountAdvertiserInfo({
  payload: { accountId, data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(SERVICES_API_V1.patchTaxInfo, {
      accountId,
      data: data,
    })

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    fields && reject(new SubmissionError({ advertiser_info: { ...fields } }))

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }
  } finally {
    yield put(stopSubmit(formName))
  }
}

export default function* Sagas() {
  yield takeLatest(PATCH_ACCOUNT_ADVERTISER_INFO, patchAccountAdvertiserInfo)
}
